import { apiClient, handleApiError } from './api.js';

class PhysicianService {
  async getAllPhysicians() {
    try {
      const response = await apiClient.get('/Physician');
      return response.data;
    } catch (error) {
      console.error('Error fetching physicians:', error);
      throw handleApiError(error);
    }
  }

  async getActivePhysicians() {
    try {
      const response = await apiClient.get('/Physician/active');
      return response.data;
    } catch (error) {
      console.error('Error fetching active physicians:', error);
      // Fallback to mock data if API fails
      console.warn('Falling back to mock data for physicians');
      return [
        { id: 1, firstName: 'John', lastName: 'Smith', specialization: 'Cardiology' },
        { id: 2, firstName: 'Sarah', lastName: 'Johnson', specialization: 'Pediatrics' },
        { id: 3, firstName: 'Michael', lastName: 'Brown', specialization: 'Orthopedics' }
      ];
    }
  }

  async getPhysicianById(physicianId) {
    try {
      const response = await apiClient.get(`/Physician/${physicianId}`);
      return response.data;
    } catch (error) {
      console.error(`Error fetching physician ${physicianId}:`, error);
      throw handleApiError(error);
    }
  }

  async getPhysiciansForDropdown() {
    try {
      const response = await apiClient.get('/Physician/dropdown');
      return response.data;
    } catch (error) {
      console.error('Error fetching physicians for dropdown:', error);
      throw handleApiError(error);
    }
  }
}

export default new PhysicianService();